import React, { FC, useMemo } from 'react'
import Typography from 'transfix-ui/core/Typography'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import { CUSTOMER_LABELS_TYPE } from 'apps/fleet-planner/constants/loads'
import { CUSTOMER_LABELS } from './constants'

export interface ICustomerDetailsProps {
  customerLabels?: CUSTOMER_LABELS_TYPE[]
}

export const CustomerDetails: FC<ICustomerDetailsProps> = ({ customerLabels = [] }) => {
  const fmsTargetDedicatedShipments = useFeatureFlag('fmsTargetDedicatedShipments')

  const customerDetailParts = useMemo(
    () => (fmsTargetDedicatedShipments ? customerLabels.map(label => CUSTOMER_LABELS[label]) : []),
    [customerLabels, fmsTargetDedicatedShipments]
  )

  return (
    <>
      <Typography variant='subtitle2' color='textSecondary'>
        {customerDetailParts.join(' ,')}
      </Typography>
    </>
  )
}
